module.exports = __webpack_public_path__ + "img/c-finance-2.png";